// import axios from "../../../src/core/api/axiosClientOTA";
import axios from "../../../../src/core/api/axiosClientOTA";

export const getOTA = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/OTA/Get`, {
    params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    signal,
  });

  return res?.data;
};
